module.exports = __webpack_public_path__ + "static/media/featured_image_1.b22a2dfa.jpeg";